import { render } from "./WindChart.vue?vue&type=template&id=05ead9ef"
import script from "./WindChart.vue?vue&type=script&lang=js"
export * from "./WindChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__